import React from 'react'

import config from '../config.js'

import { Link } from 'react-router-dom'

const ListFriend = ({ friend, friendsPath }) => (
  <li className="friends-list-item">
    <Link to={friendsPath + '/list/' + friend.identifier + '/cookbooks'}>
      <img
        className="friends-list-item__img"
        src={
          friend.avatarUrl == null
            ? config.baseUrl + '/assets/img/generic-avatar-medium.png'
            : friend.avatarUrl + '=s96-c'
        }
        alt={friend.name + ' Avatar'}
      />
    </Link>
    <h3 className="friends-list-item__name">
      <Link to={friendsPath + '/list/' + friend.identifier + '/cookbooks'}>
        {friend.name}
      </Link>
    </h3>
    <Link
      className="friends-list-item__link"
      to={friendsPath + '/list/' + friend.identifier + '/cookbooks'}
    >
      View Recipes
    </Link>
    <br />
    <Link
      className="friends-list-item__link"
      to={friendsPath + '/messages/' + friend.accountId}
    >
      Send a Message
    </Link>
  </li>
)

export default ListFriend



// WEBPACK FOOTER //
// ./src/Components/ListFriend.js